// Popup announcements closed without being read stay closed for 24 hours in this browser
// (docs/plans/site-announcements-design.md, "Frontend"). The map of popup ids to expiry times (ms) lives in
// localStorage; without storage (blocked, full, private mode) a closed popup simply opens again on the next page.
export const HIDDEN_POPUPS_KEY = 'inapp_popup_hidden_until';
export const HIDE_FOR_MS = 24 * 60 * 60 * 1000;
const POPUP_ID = /^[1-9]\d{0,18}$/;

// The unexpired entries; anything malformed is dropped.
function readHidden(now) {
    let stored;
    try {
        stored = JSON.parse(window.localStorage.getItem(HIDDEN_POPUPS_KEY) || '{}');
    } catch (error) {
        return {};
    }
    const hidden = {};
    if (stored && typeof stored === 'object' && !Array.isArray(stored)) {
        Object.entries(stored).forEach(([id, until]) => {
            if (POPUP_ID.test(id) && Number.isFinite(until) && until > now) {
                hidden[id] = until;
            }
        });
    }
    return hidden;
}

function writeHidden(hidden) {
    try {
        window.localStorage.setItem(HIDDEN_POPUPS_KEY, JSON.stringify(hidden));
    } catch (error) {
        // Without storage the popup opens again on the next page.
    }
}

// The ids of the popups closed less than 24 hours ago; expired and malformed entries are pruned.
export function hiddenPopupIds(now = Date.now()) {
    const hidden = readHidden(now);
    writeHidden(hidden);
    return new Set(Object.keys(hidden).map(Number));
}

export function hidePopupForADay(id, now = Date.now()) {
    const hidden = readHidden(now);
    hidden[String(Number(id))] = now + HIDE_FOR_MS;
    writeHidden(hidden);
}
